import { Injectable, EventEmitter } from '@angular/core';
import { SignalRService, SignalREventService, Section, DataArray } from './../index';

@Injectable()
export class SectionService {
    public sectionsChange: EventEmitter<Section[]> = new EventEmitter<Section[]>();
    public sections: DataArray<Section> = new DataArray<Section>();

    constructor(
        private _signalRService: SignalRService,
        private _signalREventService: SignalREventService
    ) {
        this.registerOnServerEvents();
    }

    public getSections(): void{
        if (this.sections.Data.length === 0) {
            this._signalRService.invoke('GetSections');
        }
        else {
            this.sectionsChange.emit(this.sections.Data);
        }
    }

    private onSections(info: any): void {
        this.sections.init();

        for (const item of info.Data.Sections) {
            const section: Section = $.extend(new Section(), item);
            this.sections.push(section);
        }

        this.sectionsChange.emit(this.sections.Data);
    }

    private registerOnServerEvents() {
        this._signalREventService.register('SectionService', 'sections', (info: any) => this.onSections(info));
    }


    public deregisterOnServerEvents(): void {
        this._signalREventService.deregister('SectionService');
    }
}
